import { gql } from 'apollo-angular';
import { parentDomainItemFragment } from '../parent-domain/parent-domain.fragments';

export const dashboardItemFragment = gql`
  fragment DashboardItemFragment on Dashboard {
    id
    title
    dashboardFormat {
      id
      shortName
    }
  }
`;

export const dashboardViewerCanFragment = gql`
  fragment DashboardViewerCanFragment on Dashboard {
    id
    viewerCanRead
    viewerCanManage
  }
`;

export const dashboardFormatItemFragment = gql`
  fragment DashboardFormatItemFragment on DashboardFormat {
    id
    title
    shortName
    parentDomains {
      nodes {
        ...ParentDomainItemFragment
      }
    }
  }
  ${parentDomainItemFragment}
`;
